/** API route map: URLS.Controller.CandidateEducation */
export const CandidateEducation = {
      Name: 'CandidateEducation/',
      GetEducations: 'get-all',
      AddEducation: 'add',
      UpdateEducation: 'update',
      DeleteEducation: 'delete',
};
